// extracted by mini-css-extract-plugin
export default {"root":"style_root__IcfIT","content":"style_content__ho1cu","empty":"style_empty__Kz97T","headerTitle":"style_headerTitle__zLP+Y"};